<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      entity-name="PrintGroupManagement"
      :model="model"
      icon="mdi-cards"
    >
      <template #right>
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          :style="!$vuetify.breakpoint.mdAndUp ? '' : 'background: white !important'"
          elevation="0"
          outlined
          @click="printerSetting = true"
        >
          <v-icon
            color="black"
            left
          >
            mdi-printer-settings
          </v-icon>
          {{ $t('FastPrintConfiguration') }}
        </v-btn>
      </template>
      <template #footer>
        <!-- Display information about print groups here if needed -->
      </template>
    </ik-data-table>
    <v-dialog v-model="printerSetting">
      <v-card class="pa-8">
        <div class="d-flex align-center">
          <div class="text-h3">
            {{ $t('FastPrintConfiguration') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="printerSetting = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :items-per-page="100"
          :loading="loading"
          class="mt-4"
          dense
          hide-default-footer
        >
          <template
            v-for="(s, idx) in sectionHeaders"
            #[`item.${s.name}`]="{ item }"
          >
            <v-checkbox
              :key="idx"
              :disabled="loading"
              :input-value="item[s.name]"
              @click="updateSection(item, s.name, s.id)"
            />
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import PrinterGroup from '@/model/dataLayer/api/print/PrinterGroup'
import DeviceList from '@/model/dataLayer/api/print/DeviceList'
import { hillo } from 'hillo'

export default {
  name: 'PrintGroup',
  components: {
    IkDataTable
  },
  data () {
    return {
      loading: false,
      sectionHeaders: [],
      fixedHeader: [
        {
          text: 'name',
          value: 'name'
        },
        {
          text: 'sn',
          value: 'sn'
        }
      ],
      displayData: [],
      printerSetting: false,
      model: PrinterGroup
    }
  },
  computed: {
    headers () {
      return this.fixedHeader.concat(this.sectionHeaders)
    },
    tableData () {
      const tableData = []
      this.displayData.forEach(d => {
        d.name = d.printerName
        this.sectionHeaders.forEach(s => {
          if (d.groupId) {
            d[s.name] = (d.groupId.indexOf(parseFloat(s.id)) > -1)
          }
        })
        tableData.push(d)
      })
      console.log(tableData, 'table')
      return tableData
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async updateSection (item, sName, sId) {
      this.loading = true
      item[sName] = !item[sName]
      if (item[sName]) {
        item.groupId.push(sId)
      } else {
        item.groupId.splice(item.groupId.indexOf(sId), 1)
      }
      item.groupIds = JSON.stringify(item.groupId)
      await hillo.post('Printer.php?op=edit', item)
      this.loading = false
    },
    async reload () {
      this.sectionHeaders = (await PrinterGroup.getList()).map(a => {
        a.text = a.name
        a.value = a.name
        return a
      })
      this.displayData = (await DeviceList.getList())
    }
  }
}
</script>

<style scoped>

</style>
